import { SentinelVisit } from '../SentinelVisit.js';

function SentinelService($interval, $q, $resource, $rootScope, $location, $http, sentinelSearchCriteriaFactory) {
    var sentinel = {
            baseUrl: $location.protocol() + '://' + $location.host() + ($location.port() !== 80 ? ":" + $location.port() : ''),
            logId: null,
            activeTab: localStorage.getItem('sentinelTab') ? localStorage.getItem('sentinelTab') : 'visits',
            latestRegistered: moment("01-01-2017", "MM-DD-YYYY"),
            latestActive: moment("01-01-2017", "MM-DD-YYYY"),
            latest: moment().startOf('day'),
            callbacks: [],
            visitData: {
                registeredGuests: [],
                activeVisitors: [],
                visits: []
            },
            initialized: false,
            updateInterval: null,
            templateData: null,
            templateSegments: null,
            searchCriteria: sentinelSearchCriteriaFactory.get(),
            registeredPromise: null,
            activePromise: null,
            searchPromise: null,
            requestCancelled: false,
            facilities: {},
            facilitiesLastUpdated: null,
            facilityUpdatePromise: null
        },
        sentinelResource = $resource('/api/sentinel/getAllFacilityVisits/:logId', {logId: '@id'}, {
        getLocationsList: {
            method: "GET",
            url: "/api/logConfigs",
            params: {logId: "@logId", hierarchy: "logbook.provision", keyLike: "@keyLike"},
            isArray: false
        },
        getFacilityInfo: {
            method: "GET",
            url: "/api/logConfigs",
            params: {logId: "@logId", hierarchy: "logbook.provision", key: "@key"},
            isArray: false
        },
        getDefaultPage: {
            method: "GET",
            url: "/api/logConfigs",
            params: {logId: "@logId", hierarchy: "logbook.webui.config", key: "defaultLogPage"},
            isArray: false
        },
        getNotes: {
            method: "GET",
            url: "/api/notes",
            params: {logId: "@logId", size: 1000000, projection: "noteProjectionSentinel", templateName: "Sentinel"},
            'noErrorPopup': true,
            isArray: false
        },
        getNote: {
            method: "GET",
            url: "/api/notes/:noteId",
            params: {noteId: "@noteId"}
        },
        createNote: {
            method: "POST",
            url: "/api/notes"
        },
        updateNote: {
            method: "PATCH",
            url: "/api/notes/:noteId",
            params: {noteId: "@noteId"}
        },
        removeNote: {
            method: "DELETE",
            url: "/api/notes/:noteId",
            params: {noteId: "@noteId"}
        },
        addComment: {
            method: "POST",
            url: "/api/noteComments",
            params: {note: "@note", comment: "@comment"}
        },
        getTemplateData: {
            method: "GET",
            url: "/api/templates",
            params: {size: 10000, 'log.global': true, name: 'Sentinel'}
        },
        getTemplateSegments: {
            method: "GET",
            url: "/api/templateSegments",
            params: {size: 10000, sort: 'sortOrder', "template.name": "Sentinel", "template.log.global": true}
        },
        getTagByName: {
            method: "GET",
            url: "/api/tagValues",
            params: {log: "@logId", stringValue: "@tagName"}
        },
        getTagByNote: {
            method: "GET",
            url: "/api/notes/:noteId/tagValues",
            params: {noteId: "@noteId"}
        },
        createTag: {
            method: "POST",
            url: "/api/tagValues"
        },
        getFile: {
            method: "GET",
            url: "/api/files/:fileId",
            params: {fileId: "@fileId"}
        },
        getUserDetails: {
            method: "GET",
            url: "/api/logBookUserDetails/:userId",
            params: {userId: "@userId"}
        }
        }),
        refreshTimeout = 30000;

    function errorCallbackSearch() {
        if (!sentinel.requestCancelled) {
            sentinel.searchPromise = null;
            $rootScope.$broadcast('sentinel-update-failed');
        } else {
            sentinel.requestCancelled = false;
        }
    }

    function errorCallbackRegistered() {
        if (!sentinel.requestCancelled) {
            sentinel.registeredPromise = null;
            $rootScope.$broadcast('sentinel-update-failed');
        } else {
            sentinel.requestCancelled = false;
        }
    }

    function errorCallbackActive() {
        if (!sentinel.requestCancelled) {
            sentinel.activePromise = null;
            $rootScope.$broadcast('sentinel-update-failed');
        } else {
            sentinel.requestCancelled = false;
        }
    }

    this.generateUiData = function(data) {
        data.forEach(function (visit) {
            visit.formattedName = (visit.lastName ? visit.lastName + ", " : "") + visit.firstName;

            var diff = moment.duration(moment((visit.checkOutTime!=null) ? visit.checkOutTime : new Date()).diff(moment(visit.checkInTime)));
            var days =  parseInt(diff.asDays());
            var hours =  parseInt(diff.asHours());
            hours = hours - days*24;
            var minutes = parseInt(diff.asMinutes());
            minutes = minutes - (days*24*60 + hours*60);

            visit.duration = parseInt(diff.asMinutes());
            visit.durationDays = days;
            visit.durationHours = hours;
            visit.durationMinutes = minutes;

            visit.warningLevel = 0;
            if (days >= 1) {
                visit.warningLevel = 2;
            } else if (hours >= 8) {
                visit.warningLevel = 1;
            }
        });

        return data;
    };

    function updateFacilities(logId) {
        var deferred = $q.defer();

        sentinelResource.getLocationsList({logId: logId, keyLike: "Sentinel.instance.Facility%"}).$promise.then(function (response) {
            response._embedded.logConfigs.forEach(function(logConfig) {
                var value = JSON.parse(logConfig.value),
                    id = logConfig._links.self.href.split('/').pop();
                sentinel.facilities[value.facilityName] = {id: id, accessPoints: [], requiredFields: value.dataEntry, badgeId: value.badgeCode, selfCheckout: value.permitSelfCheckout};
                if (!value.dataEntry) {
                    sentinel.facilities[value.facilityName].requiredFields = {
                        firstName: 'required',
                        lastName: 'required',
                        company: 'optional',
                        visiting: 'optional',
                        reason: 'optional',
                        telephone: 'optional',
                        isCitizen: 'disabled',
                        nda: 'disabled'
                    };
                } else sentinel.facilities[value.facilityName].requiredFields = value.dataEntry;
            });

            sentinelResource.getLocationsList({logId: logId, keyLike: "Sentinel.instance.Door%"}).$promise.then(function(response) {
                deferred.resolve(parseAccessPointsData(response));
            });
        });

        sentinel.facilityUpdatePromise = deferred.promise;
        return deferred.promise;

        function parseAccessPointsData(logConfigData) {
            // Clear each list of accessPoints
            Object.keys(sentinel.facilities).forEach(function (key) {
                sentinel.facilities[key].accessPoints = [];
            });

            // FIll each list with correct accessPoints
            logConfigData._embedded.logConfigs.forEach(function(logConfig) {
                var value = JSON.parse(logConfig.value),
                    id = value.facility.split('/').pop(),
                    accessPoint = value.accessPointName;

                Object.keys(sentinel.facilities).forEach(function (key) {
                    if (!sentinel.facilities[key].id || sentinel.facilities[key].id !== id) return;

                    sentinel.facilities[key].accessPoints.push(accessPoint);
                    sentinel.facilities[key].accessPoints.sort();
                });
            });

            sentinel.facilityUpdatePromise = null;
            sentinel.facilitiesLastUpdated = moment();
        }
    }

    function getData() {
        if (!sentinel.logId) {
            return;
        }

        $rootScope.$broadcast("sentinel-update-start");

        var canceller = $q.defer();
        var templateValueQuery = getFilterQuery();
        var params = {
            logId: sentinel.logId,
            size: sentinel.searchCriteria.size || 10000,
            page: sentinel.searchCriteria.page || 0,
            templateName: "Sentinel",
            projection: "noteProjectionSentinel",
            templateValueQuery: templateValueQuery
        };

        sentinel.searchPromise = $http.get('/api/notes', {
            params: params,
            timeout: canceller.promise,
            'noErrorPopup': true
        });

        sentinel.searchPromise.cancelRequest = function () {
            sentinel.requestCancelled = true;
            canceller.promise.suppressErrorFlag = true;
            canceller.resolve();
            return canceller.promise;
        };

        sentinel.searchPromise.then(function (newData) {
            sentinel.searchPromise = null;
            sentinel.visitData.visits.splice(0, sentinel.visitData.visits.length);

            var pendingWatermarker = sentinel.latest;
            newData.data._embedded.notes.forEach(function (visit) {
                var visitUpdateTime = moment(visit.updated);
                if (visitUpdateTime > pendingWatermarker) pendingWatermarker = visitUpdateTime;
                var newVisit = new SentinelVisit(visit);

                sentinel.visitData.visits.push(newVisit)
            });

            sentinel.latest = pendingWatermarker;
            $rootScope.$broadcast('sentinel-update-successful', {updateTime: moment()});
        }, errorCallbackSearch);

        return sentinel.searchPromise;
    }

    function updateData() {
        if (!sentinel.logId) {
            return;
        }

        $rootScope.$broadcast("sentinel-update-start");

        var canceller = $q.defer();
        var params = {
            logId: sentinel.logId,
            size: sentinel.searchCriteria.size || 10000,
            page: sentinel.searchCriteria.pageNumber || 0,
            templateName: "Sentinel",
            projection: "noteProjectionSentinel",
            updatedFromDate: moment(sentinel.latest).toDate()
        };

        sentinel.searchPromise = $http.get('/api/notes', {
            params: params,
            timeout: canceller.promise,
            'noErrorPopup': true
        });

        sentinel.searchPromise.cancelRequest = function () {
            sentinel.requestCancelled = true;
            canceller.promise.suppressErrorFlag = true;
            canceller.resolve();
            return canceller.promise;
        };

        function matchesCriteria(visit) {
            var matches = true;

            var fromDateStart = sentinel.searchCriteria.fromDate ? new Date(sentinel.searchCriteria.fromDate).setHours(0, 0, 0, 0) : null;
            var fromDateEnd = sentinel.searchCriteria.fromDate ? new Date(sentinel.searchCriteria.fromDate).setHours(23, 59, 59, 999) : null;
            var thruDateEnd = sentinel.searchCriteria.thruDate ? new Date(sentinel.searchCriteria.thruDate).setHours(23, 59, 59, 999) : null;

            var dateStart = fromDateStart ? fromDateStart : null;
            var dateEnd = sentinel.searchCriteria.useDateRange ? (thruDateEnd ? thruDateEnd : null) : (fromDateEnd ? fromDateEnd : null);

            var visitInTime = visit.checkInTime ? moment(visit.checkInTime) : null;
            var visitOutTime = visit.checkOutTime ? moment(visit.checkOutTime) : null;

            if (dateStart && dateEnd) {
                if (!((visitInTime && (visitInTime.isBefore(dateEnd) || visitInTime.isSame(dateEnd))) && ((visitOutTime && (visitOutTime.isAfter(dateStart) || visitOutTime.isSame(dateStart))) || !visitOutTime))) {
                    matches = false;
                }
            } else if (dateStart && !dateEnd) {
                if (!((visitOutTime && (visitOutTime.isAfter(dateStart) || visitOutTime.isSame(dateStart))) || !visitOutTime)) {
                    matches = false;
                }
            } else if (!dateStart && dateEnd) {
                if (!(visitInTime && (visitInTime.isBefore(dateEnd) || visitInTime.isSame(dateEnd)))) {
                    matches = false;
                }
            }

            if (sentinel.searchCriteria.searchTerm) {
                var searchTermWords = sentinel.searchCriteria.searchTerm.split(' ');
                for (var i = 0; i < searchTermWords.length; i++) {
                    if (!((visit.lastName && visit.lastName.toLowerCase().includes(searchTermWords[i].toLowerCase())) ||
                        (visit.firstName && visit.firstName.toLowerCase().includes(searchTermWords[i].toLowerCase())) ||
                        (visit.doorIn && visit.doorIn.toLowerCase().includes(searchTermWords[i].toLowerCase())) ||
                        (visit.doorOut && visit.doorOut.toLowerCase().includes(searchTermWords[i].toLowerCase())) ||
                        (visit.escortIn && visit.escortIn.toLowerCase().includes(searchTermWords[i].toLowerCase())) ||
                        (visit.escortOut && visit.escortOut.toLowerCase().includes(searchTermWords[i].toLowerCase())) ||
                        (visit.visiting && visit.visiting.toLowerCase().includes(searchTermWords[i].toLowerCase())) ||
                        (visit.company && visit.company.toLowerCase().includes(searchTermWords[i].toLowerCase())) ||
                        (visit.reason && visit.reason.toLowerCase().includes(searchTermWords[i].toLowerCase())) ||
                        (visit.badgeCodeManual && visit.badgeCodeManual.toLowerCase().includes(searchTermWords[i].toLowerCase())) ||
                        (visit.facilityName && visit.facilityName.toLowerCase().includes(searchTermWords[i].toLowerCase())))) {
                        matches = false;
                    }
                }
            }

            if (sentinel.searchCriteria.facilityFilter) {
                if (visit.facilityName !== sentinel.searchCriteria.facilityFilter) {
                    matches = false;
                }
            }

            return matches;
        }

        sentinel.searchPromise.then(function (newData) {
            sentinel.searchPromise = null;

            var pendingWatermarker = sentinel.latest;
            newData.data._embedded.notes.forEach(function (visit) {
                var visitUpdateTime = moment(visit.updated);
                if (visitUpdateTime > pendingWatermarker) pendingWatermarker = visitUpdateTime;

                var newVisit = new SentinelVisit(visit);

                var matches = matchesCriteria(newVisit);

                if (matches) {
                    var foundIndex;
                    if (Array.prototype.findIndex) {
                        foundIndex = sentinel.visitData.visits.findIndex(function (existingVisit) {
                            return existingVisit.noteId === newVisit.noteId;
                        });
                    } else {
                        for (var i = 0; i < sentinel.visitData.visits.length; i++) {
                            if (sentinel.visitData.visits[i].noteId === newVisit.noteId) {
                                foundIndex = i;
                                break;
                            } else if (i === sentinel.visitData.visits.length - 1) {
                                foundIndex = -1;
                            }
                        }
                    }

                    if (foundIndex < 0) {
                        sentinel.visitData.visits.push(newVisit);
                    } else {
                        sentinel.visitData.visits[foundIndex] = newVisit;
                    }
                } else {
                    var foundIndex;
                    if (Array.prototype.findIndex) {
                        foundIndex = sentinel.visitData.visits.findIndex(function (existingVisit) {
                            return existingVisit.noteId === newVisit.noteId;
                        });
                    } else {
                        for (var i = 0; i < sentinel.visitData.visits.length; i++) {
                            if (sentinel.visitData.visits[i].noteId === newVisit.noteId) {
                                foundIndex = i;
                                break;
                            } else if (i === sentinel.visitData.visits.length - 1) {
                                foundIndex = -1;
                            }
                        }
                    }

                    if (foundIndex >= 0) {
                        sentinel.visitData.visits.splice(foundIndex, 1);
                    }
                }
            });

            sentinel.latest = pendingWatermarker;
            $rootScope.$broadcast('sentinel-update-successful', {updateTime: moment()});
        }, errorCallbackSearch);

        return sentinel.searchPromise;
    }

    function getRegisteredGuests(clearExisting) {
        if (!sentinel.logId) {
            return;
        }

        $rootScope.$broadcast("sentinel-update-start");

        var canceller = $q.defer();
        var facilityQuery = 'note =hasTemplateValueShortName=("facility", "string_value == \'' + sentinel.searchCriteria.facilityFilter + '\'")';
        var templateValueQuery = 'note =hasNoTemplateValueShortName=("Check-in Time", "datetime_value != null") and note =hasNoTemplateValueShortName=("Check-out Time", "datetime_value != null")';
        if (sentinel.searchCriteria.facilityFilter) {
            templateValueQuery = templateValueQuery + ' and ' + facilityQuery;
        }

        if (clearExisting) { sentinel.latestRegistered = moment("01-01-2017", "MM-DD-YYYY"); }

        var params = {
            logId: sentinel.logId,
            size: 10000,
            templateName: "Sentinel",
            projection: "noteProjectionSentinel",
            updatedFromDate: moment(sentinel.latestRegistered).toDate(),
            draft: true,
            templateValueQuery: templateValueQuery
        };

        sentinel.registeredPromise = $http.get('/api/notes', {
            params: params,
            timeout: canceller.promise,
            'noErrorPopup': true
        });

        sentinel.registeredPromise.cancelRequest = function () {
            sentinel.requestCancelled = true;
            canceller.promise.suppressErrorFlag = true;
            canceller.resolve();
            return canceller.promise;
        };

        sentinel.registeredPromise.then(function (newData) {
            sentinel.registeredPromise = null;

            if (clearExisting) { sentinel.visitData.registeredGuests.splice(0, sentinel.visitData.registeredGuests.length); }

            var pendingWatermarker = sentinel.latestRegistered;
            newData.data._embedded.notes.forEach(function (visit) {
                var visitUpdateTime = moment(visit.updated);
                if (visitUpdateTime > pendingWatermarker) pendingWatermarker = visitUpdateTime;
                var newVisit = new SentinelVisit(visit);

                if (!clearExisting) {
                    var foundIndex = null;
                    for (var i = 0; i < sentinel.visitData.registeredGuests.length; i++) {

                        if (sentinel.visitData.registeredGuests[i].noteId === newVisit.noteId) {
                            foundIndex = i;
                            break;
                        }
                    }

                    if (foundIndex) {
                        sentinel.visitData.registeredGuests.push(newVisit);
                    } else {
                        sentinel.visitData.registeredGuests[foundIndex] = newVisit;
                    }
                } else {
                    sentinel.visitData.registeredGuests.push(newVisit);
                }

            });

            sentinel.latestRegistered = pendingWatermarker;
            $rootScope.$broadcast('sentinel-update-successful', {updateTime: moment()});
        }, errorCallbackRegistered);

        return sentinel.registeredPromise;
    }

    function getActiveVisitors(clearExisting) {
        if (!sentinel.logId) {
            return;
        }

        var canceller = $q.defer();
        var facilityQuery = 'note =hasTemplateValueShortName=("facility", "string_value == \'' + sentinel.searchCriteria.facilityFilter + '\'")';
        var templateValueQuery = 'note =hasTemplateValueShortName=("Check-in Time", "datetime_value != null") and note =hasNoTemplateValueShortName=("Check-out Time", "datetime_value != null")';
        if (sentinel.searchCriteria.facilityFilter) {
            templateValueQuery = templateValueQuery + ' and ' + facilityQuery;
        }

        if (clearExisting) { sentinel.latestActive = moment("01-01-2017", "MM-DD-YYYY"); }

        var params = {
            logId: sentinel.logId,
            size: 10000,
            templateName: "Sentinel",
            projection: "noteProjectionSentinel",
            updatedFromDate: moment(sentinel.latestActive).toDate(),
            templateValueQuery: templateValueQuery
        };

        sentinel.activePromise = $http.get('/api/notes', {
            params: params,
            timeout: canceller.promise,
            'noErrorPopup': true
        });

        sentinel.activePromise.cancelRequest = function () {
            sentinel.requestCancelled = true;
            canceller.promise.suppressErrorFlag = true;
            canceller.resolve();
            return canceller.promise;
        };

        sentinel.activePromise.then(function (newData) {
            sentinel.activePromise = null;

            if (clearExisting) { sentinel.visitData.activeVisitors.splice(0, sentinel.visitData.activeVisitors.length); }

            var pendingWatermarker = sentinel.latestActive;
            newData.data._embedded.notes.forEach(function (visit) {
                var visitUpdateTime = moment(visit.updated);
                if (visitUpdateTime > pendingWatermarker) pendingWatermarker = visitUpdateTime;
                var newVisit = new SentinelVisit(visit);

                if (!clearExisting) {
                    var foundIndex = null;
                    for (var i = 0; i < sentinel.visitData.activeVisitors.length; i++) {
                        if (sentinel.visitData.activeVisitors[i].noteId === newVisit.noteId) {
                            foundIndex = i;
                            break;
                        }
                    }

                    if (foundIndex) {
                        sentinel.visitData.activeVisitors.push(newVisit);
                    } else {
                        sentinel.visitData.activeVisitors[foundIndex] = newVisit;
                    }
                } else {
                    sentinel.visitData.activeVisitors.push(newVisit);
                }

            });

            sentinel.latestActive = pendingWatermarker;
            $rootScope.$broadcast('sentinel-update-successful', {updateTime: moment()});
        }, errorCallbackActive);

        return sentinel.activePromise;
    }

    function getFilterQuery() {
        var templateValueQuery = null;

        var fromDateStart = sentinel.searchCriteria.fromDate ? new Date(sentinel.searchCriteria.fromDate).setHours(0, 0, 0, 0) : null;
        var fromDateEnd = sentinel.searchCriteria.fromDate ? new Date(sentinel.searchCriteria.fromDate).setHours(23, 59, 59, 999) : null;
        var thruDateEnd = sentinel.searchCriteria.thruDate ? new Date(sentinel.searchCriteria.thruDate).setHours(23, 59, 59, 999) : null;

        var dateStart = fromDateStart ? new Date(fromDateStart).toISOString() : null;
        var dateEnd = sentinel.searchCriteria.useDateRange ? (thruDateEnd ? new Date(thruDateEnd).toISOString() : null) : (fromDateEnd ? new Date(fromDateEnd).toISOString() : null);

        if (dateStart && dateEnd) {
            templateValueQuery = '(note =hasTemplateValueShortName=("Check-in Time", "datetime_value <= ' + dateEnd + '") and (note =hasTemplateValueShortName=("Check-out Time", "datetime_value >= ' + dateStart + '") or note =hasNoTemplateValueShortName=("Check-out Time", "datetime_value != null")))';
        } else if (dateStart && !dateEnd) {
            templateValueQuery = '(note =hasTemplateValueShortName=("Check-out Time", "datetime_value >= ' + dateStart + '") or note =hasNoTemplateValueShortName=("Check-out Time", "datetime_value != null"))';
        } else if (!dateStart && dateEnd) {
            templateValueQuery = 'note =hasTemplateValueShortName=("Check-in Time", "datetime_value <= ' + dateEnd + '")';
        }

        // Generate query that returns Notes containing all search terms.
        if (sentinel.searchCriteria.searchTerm) {
            // Segments in the blacklist are not included in the search.
            var queryBlacklist = ["ID", "Device ID", "Registration Time", "Automatic Badge Code", "Manual Badge Code", "Are you are U.S. Citizen?", "Have you signed an NDA with the company?"];

            var searchQuery = "(";
            var searchTermWords = sentinel.searchCriteria.searchTerm.split(' ');
            // AND each query for a search term in ANY segment
            for (var i = 0; i < searchTermWords.length; i++) {
                if (i !== 0) searchQuery += ' and ';
                searchQuery += '(';
                var placedFirstSegment = false;
                // OR each query for this search term in a segment
                for (var j = 0; j < sentinel.templateSegments.length; j++) {
                    var segmentName = sentinel.templateSegments[j].name;
                    if (sentinel.templateSegments[j].obsolete || queryBlacklist.includes(segmentName)) continue;
                    if (placedFirstSegment) searchQuery += ' or ';
                    searchQuery += 'note =hasTemplateValueShortName=("' + segmentName +'", "string_value == *' + searchTermWords[i] + '*")';
                    placedFirstSegment = true;
                }
                searchQuery += ')';
            }

            if (sentinel.searchCriteria.showComments && searchTermWords) {
                    var commentSearchQuery = "(";
                    for (var i = 0; i < searchTermWords.length; i++) {
                        if (i !== 0) commentSearchQuery += " and ";
                        commentSearchQuery += 'note.comment == "*' + searchTermWords[i] + '*"';
                    }
                    searchQuery += " or " + commentSearchQuery + ")";
            }

            searchQuery += ")";

            templateValueQuery = templateValueQuery ? templateValueQuery + ' and ' + searchQuery : searchQuery
        }

        if (sentinel.searchCriteria.facilityFilter) {
            if (templateValueQuery) templateValueQuery += ' and ';
            templateValueQuery += 'note =hasTemplateValueShortName=("Facility", "string_value == \'' + sentinel.searchCriteria.facilityFilter + '\'")';
        }

        return templateValueQuery;
    };

    this.getFacilitiesList = function(logId) {
        var deferred = $q.defer();

        if ((!sentinel.facilitiesLastUpdated || moment().diff(sentinel.facilitiesLastUpdated, 'minutes') >= 10) && !sentinel.facilityUpdatePromise) {
            updateFacilities(logId).then(function () {
                deferred.resolve(Object.keys(sentinel.facilities).sort());
            });
        } else if (sentinel.facilityUpdatePromise) {
            sentinel.facilityUpdatePromise.then(function () {
                deferred.resolve(Object.keys(sentinel.facilities).sort());
            });
        } else deferred.resolve(Object.keys(sentinel.facilities).sort());

        return deferred.promise;
    };

    this.getRequiredFields = function(logId, facilityName) {
        var deferred = $q.defer();

        if ((!sentinel.facilitiesLastUpdated || moment().diff(sentinel.facilitiesLastUpdated, 'minutes') >= 10) && !sentinel.facilityUpdatePromise) {
            updateFacilities(logId).then(function () {
                deferred.resolve(returnRequiredFields());
            });
        } else if (sentinel.facilityUpdatePromise) {
            sentinel.facilityUpdatePromise.then(function () {
                deferred.resolve(returnRequiredFields());
            })
        } else deferred.resolve(returnRequiredFields());

        return deferred.promise;

        function returnRequiredFields() {
            // If no facility is selected, build requiredFields based on the requiredFields of all facilities.
            // "required", "optional", "disabled". Each takes precedence over the next.
            if (!facilityName || !sentinel.facilities[facilityName]) {
                var reqFields = {};
                Object.keys(sentinel.facilities).forEach(function(facilityName) {
                    Object.keys(sentinel.facilities[facilityName].requiredFields).forEach(function(key) {
                        var fieldVal = sentinel.facilities[facilityName].requiredFields[key];
                        if (reqFields[key] === 'required' || fieldVal === 'required') {
                            reqFields[key] = 'required';
                            return;
                        }
                        if (reqFields[key] === 'optional' || fieldVal === 'optional') {
                            reqFields[key] = 'optional';
                            return;
                        }
                        reqFields[key] = 'disabled';
                        return;
                    });
                });
                return reqFields;
            }
            else return sentinel.facilities[facilityName].requiredFields;
        }
    };

    this.getBadgesRequired = function(logId, facilityName) {
        var deferred = $q.defer();

        if ((!sentinel.facilitiesLastUpdated || moment().diff(sentinel.facilitiesLastUpdated, 'minutes') >= 10) && !sentinel.facilityUpdatePromise) {
            updateFacilities(logId).then(function () {
                deferred.resolve(sentinel.facilities[facilityName].badgeId);
            });
        } else if (sentinel.facilityUpdatePromise) {
            sentinel.facilityUpdatePromise.then(function () {
                deferred.resolve(sentinel.facilities[facilityName].badgeId);
            });
        } else deferred.resolve(sentinel.facilities[facilityName].badgeId);

        return deferred.promise;
    };

    this.getSelfCheckout = function(logId, facilityName) {
        var deferred = $q.defer();

        if ((!sentinel.facilitiesLastUpdated || moment().diff(sentinel.facilitiesLastUpdated, 'minutes') >= 10) && !sentinel.facilityUpdatePromise) {
            updateFacilities(logId).then(function () {
                deferred.resolve(sentinel.facilities[facilityName].selfCheckout);
            });
        } else if (sentinel.facilityUpdatePromise) {
            sentinel.facilityUpdatePromise.then(function () {
                deferred.resolve(sentinel.facilities[facilityName].selfCheckout);
            });
        } else deferred.resolve(sentinel.facilities[facilityName].selfCheckout);

        return deferred.promise;
    };

    this.getDefaultPage = function(logId) {
        var deferred = $q.defer();

        sentinelResource.getDefaultPage({logId: logId}).$promise.then(function (response) {
            deferred.resolve(parseFacilityData(response));
        });

        return deferred.promise;

        function parseFacilityData(logConfigData) {
            if (logConfigData._embedded.logConfigs.length === 0) {
                return '/notes';
            } else {
                var route = '/' + logConfigData._embedded.logConfigs[0].value;
                return route;
            }
        }
    };

    this.getAccessPointsList = function(logId, facilityName) {
        var deferred = $q.defer();

        if ((!sentinel.facilitiesLastUpdated || moment().diff(sentinel.facilitiesLastUpdated, 'minutes') >= 10) && !sentinel.facilityUpdatePromise) {
            updateFacilities(logId).then(function () {
                deferred.resolve(sentinel.facilities[facilityName].accessPoints);
            });
        } else if (sentinel.facilityUpdatePromise) {
            sentinel.facilityUpdatePromise.then(function () {
                deferred.resolve(sentinel.facilities[facilityName].accessPoints);
            });
        } else deferred.resolve(sentinel.facilities[facilityName].accessPoints);

        return deferred.promise;
    };

    this.getFile = function (fileId) {
        return sentinelResource.getFile({fileId: fileId}).$promise;
    };

    this.getFilteredVisitors = function() {

    };

    // Dictionary for mapping values to Sentinel template fields
    var templateNameMap = {
        firstName: {name: "First Name", id: null},
        lastName: {name: "Last Name", id: null},
        checkInTime: {name: "Check-in Time", id: null},
        checkOutTime: {name: "Check-out Time", id: null},
        doorIn: {name: "Door In", id: null},
        doorOut: {name: "Door Out", id: null},
        escortIn: {name: "Escort In", id: null},
        escortOut: {name: "Escort Out", id: null},
        visiting: {name: "Visiting", id: null},
        company: {name: "Company", id: null},
        reason: {name: "Reason", id: null},
        telephone: {name: "Telephone", id: null},
        isCitizen: {name: "Are you a U.S. Citizen?", id: null},
        nda: {name: "Have you signed an NDA with the company?", id: null},
        badgeCodeManual: {name: "Manual Badge Code", id: null},
        profilePicture: {name: "Profile Picture", id: null},
        id: {name: "ID", id: null},
        deviceId: {name: "Device ID", id: null},
        facilityName: {name: "Facility", id: null},
        lastEdit: {name: "Last Edit", id: null},
        timeRegistered: { name: "Registration Time", id: null },
        removed: {name: "Removed", id: null}
    };

    // Transforms an object to template segments using the templateNameMap dictionary
    function transformVisitToTemplateData(templateSegments, visit, allowNull) {
        var templateValArr = [],
            templateObjsBeingMapped = [];

        //Find a templateSegment whose key matches the object's property name.
        templateSegments.forEach(function (segment) {
            Object.keys(visit).forEach(function (key) {
                if (!allowNull) {
                    if (templateNameMap[key] !== null && templateNameMap[key] !== undefined && visit[key] !== null && visit[key] !== undefined && templateNameMap[key].name === segment.name && segment.obsolete === false) {
                        templateObjsBeingMapped.push(createTemplateValueObj(visit[key], segment).then(function (templateObj) {
                            templateValArr.push(templateObj);
                        }));
                    }
                } else if (allowNull) {
                    if (templateNameMap[key] !== null && templateNameMap[key] !== undefined && templateNameMap[key].name === segment.name && segment.obsolete === false && (segment.type.name !== 'File Attachment' || (visit[key] !== null && visit[key] !== undefined))) {
                        templateObjsBeingMapped.push(createTemplateValueObj(visit[key], segment).then(function (templateObj) {
                            templateValArr.push(templateObj);
                        }));
                    }
                }
            });
        });

        return $q.all(templateObjsBeingMapped).then(function () {
            return templateValArr;
        });
    }

    // Transforms template segments type to appropriate format for posting
    function createTemplateValueObj(objVal, segment) {
        var deferredQueue = [],
            templateValObj = {templateSegmentId: segment.id},
            keyName = "";

        if (segment.type.name === "Text Input") keyName = "stringValue";
        if (segment.type.name === "Date/Time") {
            keyName = "dateTimeValue";
            objVal = objVal ? new Date(objVal).toISOString() : objVal;
        }
        if (segment.type.name === "File Attachment") {
            keyName = "fileAttachments";
            objVal = objVal ? [sentinel.baseUrl + "/api/files/" + objVal] : objVal;
        }
        if (segment.type.name === "Checkbox") {
            keyName = "stringValue";
            objVal = objVal === "checked" ? "checked" : "unchecked";
        }

        return $q.all(deferredQueue).then(function() {
            templateValObj[keyName] = objVal;
            return templateValObj;
        });
    }

    function dataURItoBlob(dataURI, callback) {
        var byteString = atob(dataURI.split(',')[1]);
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        var intArray = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            intArray[i] = byteString.charCodeAt(i);
        }

        callback((new Blob([intArray], {type: mimeString})));
    }

    function createTag(tagName) {
        var tagNameNoSpaces = tagName.replace(/\s/g, '');

        var tagToCreate = {
            log: sentinel.baseUrl + '/api/logs/' + $rootScope.selectedLog.id,
            stringValue: tagNameNoSpaces,
            description: tagName
        };

        return sentinelResource.createTag({}, tagToCreate).$promise;
    }

    function uploadAttachment(attachment, visit) {
        var deferred = $q.defer();

        var formData = new FormData();
        formData.append('logId', $rootScope.selectedLog.id);
        formData.append('description', 'Picture of ' + visit.firstName + ' ' + visit.lastName);
        formData.append('fileDate', new Date().toISOString());
        dataURItoBlob(attachment, function (result) {
            formData.append('file', result, 'image.png');
            var config = {
              transformRequest: angular.identity,
              headers: {
                  'Content-Type': undefined
              }
            };

            $http.post(sentinel.baseUrl + "/api/files", formData, config).then(function(retVal) {
                deferred.resolve(retVal);
            });
        });
        return deferred.promise;
    }

    function generateUniqueId() {
        function r() {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }
        return r() + r() + '-' + r() + '-' + r() + '-' + r() + '-' + r() + r();
    }

    this.createRegisteredGuest = function(visit) {
        var sentinelVisitTagLink;
        var facilityTagLink;
        var promises = [];
        promises.push(sentinelResource.getTagByName({log: $rootScope.selectedLog.id, stringValue: "SentinelVisit"}).$promise);
        promises.push(sentinelResource.getTagByName({log: $rootScope.selectedLog.id, stringValue: visit.facilityName.replace(/\s/g, '')}).$promise);
        if (visit.pictureBase64) {
            promises.push(uploadAttachment(visit.pictureBase64, visit));
        }

        $q.all(promises).then(checkResponses);

        function checkResponses (data) {
            promises = [];
            if (data[0]._embedded.tagValues.length === 0) {
                promises.push(createTag("Sentinel Visit"));
            } else { sentinelVisitTagLink = data[0]._embedded.tagValues[0]._links.self.href; }
            if (data[1]._embedded.tagValues.length === 0) {
                promises.push(createTag(visit.facilityName));
            } else { facilityTagLink = data[1]._embedded.tagValues[0]._links.self.href; }
            if (data[2]) {
                visit.profilePicture = data[2].data.id;
            }

            $q.all(promises).then(successCallback);
        }

        function successCallback(data) {
            for (var i = 0; i < data.length; i++) {
                if (data[i].description === "Sentinel Visit") {
                    sentinelVisitTagLink = data[i]._links.self.href;
                } else if (data[i].description === visit.facilityName) {
                    facilityTagLink = data[i]._links.self.href;
                }
            }
            visit.id = generateUniqueId();
            visit.lastEdit = new Date();
            postNote();
        }

        function postNote() {
            transformVisitToTemplateData(sentinel.templateSegments, visit).then(function (noteTemplateValues) {
                var noteToPost = {
                    log: sentinel.baseUrl + '/api/logs/' + $rootScope.selectedLog.id,
                    newAttachments: [],
                    note: " ",
                    draft: true,
                    noteTemplateValues: noteTemplateValues,
                    noteTime: "now",
                    removeAttachments: [],
                    template: sentinel.baseUrl + '/api/templates/' + sentinel.templateData.id,
                    tagValues: [
                        sentinelVisitTagLink,
                        facilityTagLink
                    ]
                };

                if (visit.profilePicture) {
                    noteToPost.newAttachments = [visit.profilePicture];
                }

                sentinelResource.createNote({}, noteToPost).$promise.then(function(response) {
                    var noteLink = response._links.self.href;
                    var commentText = "Guest registered on the web";
                    sentinelResource.addComment({note: noteLink, comment: commentText}).$promise.then(function () {
                        performRefresh();
                    });
                });
            });
        }
    };

    this.checkInGuest = function(visit) {
        var doorTagLink;
        var promises = [];
        promises.push(sentinelResource.getTagByName({log: $rootScope.selectedLog.id, stringValue: visit.doorIn.replace(/\s/g, '')}).$promise);

        $q.all(promises).then(checkTagIds);

        function checkTagIds(data) {
            promises = [];
            if (data[0]._embedded.tagValues.length === 0) {
                promises.push(createTag(visit.doorIn));
            } else { doorTagLink = data[0]._embedded.tagValues[0]._links.self.href; }

            $q.all(promises).then(successfulTagCheck);
        }

        function successfulTagCheck(data) {
            for (var i = 0; i < data.length; i++) {
                if (data[i].description === visit.doorIn) {
                    doorTagLink = data[i]._links.self.href;
                }
            }
            visit.lastEdit = new Date();
            patchNote();
        }

        function patchNote() {
            transformVisitToTemplateData(sentinel.templateSegments, visit).then(function (noteTemplateValues) {
                var tagLinks = [];
                tagLinks.push(doorTagLink);
                sentinelResource.getTagByNote({noteId: visit.noteId}).$promise.then(function(data) {
                    for (var i = 0; i < data._embedded.tagValues.length; i++) {
                        tagLinks.push(data._embedded.tagValues[i]._links.self.href);
                    }

                    var noteToPatch = {
                        draft: false,
                        noteTemplateValues: noteTemplateValues,
                        tagValues: tagLinks
                    };

                    sentinelResource.updateNote({noteId: visit.noteId}, noteToPatch).$promise.then(function() {
                        var commentText = "Checked in on the web";
                        sentinelResource.addComment({note: visit.noteLink, comment: commentText}).$promise.then(function () {
                            performRefresh();
                        });
                    });
                });
            });
        }
    };

    this.checkOutGuest = function(visit, customCheckOutTime) {
        var doorTagLink;
        var promises = [];
        promises.push(sentinelResource.getTagByName({log: $rootScope.selectedLog.id, stringValue: visit.doorOut.replace(/\s/g, '')}).$promise);

        $q.all(promises).then(checkTagIds);

        function checkTagIds(data) {
            promises = [];
            if (data[0]._embedded.tagValues.length === 0) {
                promises.push(createTag(visit.doorOut));
            } else { doorTagLink = data[0]._embedded.tagValues[0]._links.self.href; }

            $q.all(promises).then(successfulTagCheck);
        }

        function successfulTagCheck(data) {
            for (var i = 0; i < data.length; i++) {
                if (data[i].description === visit.doorOut) {
                    doorTagLink = data[i]._links.self.href;
                }
            }
            visit.lastEdit = new Date();
            patchNote();
        }

        function patchNote() {
            transformVisitToTemplateData(sentinel.templateSegments, visit).then(function (noteTemplateValues) {
                var tagLinks = [];
                tagLinks.push(doorTagLink);
                sentinelResource.getTagByNote({noteId: visit.noteId}).$promise.then(function(data) {
                    for (var i = 0; i < data._embedded.tagValues.length; i++) {
                        tagLinks.push(data._embedded.tagValues[i]._links.self.href);
                    }

                    var noteToPatch = {
                        draft: false,
                        noteTemplateValues: noteTemplateValues,
                        tagValues: tagLinks
                    };

                    sentinelResource.updateNote({noteId: visit.noteId}, noteToPatch).$promise.then(function() {
                        var commentText;
                        if (customCheckOutTime) {
                            commentText = "Checked out on the web using a custom check-out time";
                        } else {
                            commentText = "Checked out on the web";
                        }
                        sentinelResource.addComment({note: visit.noteLink, comment: commentText}).$promise.then(function () {
                            performRefresh();
                        });
                    });
                });
            });
        }
    };

    this.undoCheckinVisitor = function (visit) {
        var noteTagLinks = [];
        var doorTagLink = null;
        var promises = [];

        promises.push(sentinelResource.getTagByName({
            log: $rootScope.selectedLog.id,
            stringValue: visit.doorIn.replace(/\s/g, '')
        }).$promise);

        $q.all(promises).then(checkTagIds);

        function checkTagIds(data) {
            if (data[0]._embedded.tagValues[0]._links.self.href) {
                doorTagLink = data[0]._embedded.tagValues[0]._links.self.href;
            }
            sentinelResource.getTagByNote({noteId: visit.noteId}).$promise.then(function (data) {
                noteTagLinks = data._embedded.tagValues.map(function (tagValue) {
                    return tagValue._links.self.href;
                });

                if (Array.prototype.includes) {
                    if (noteTagLinks.includes(doorTagLink)) {
                        noteTagLinks.splice(noteTagLinks.indexOf(doorTagLink), 1);
                    }
                } else {
                    for (var i = 0; i < noteTagLinks.length; i++) {
                        if (noteTagLinks[i] === doorTagLink) {
                            noteTagLinks.splice(noteTagLinks.indexOf(doorTagLink), 1);
                            break;
                        }
                    }
                }

                visit.doorIn = null;
                visit.escortIn = null;
                visit.checkInTime = null;
                visit.badgeCodeManual = null;
                visit.lastEdit = new Date();
                patchNote();
            });
        }

        function patchNote() {
            transformVisitToTemplateData(sentinel.templateSegments, visit, true).then(function (noteTemplateValues) {
                var noteToPatch = {
                    draft: true,
                    noteTemplateValues: noteTemplateValues,
                    tagValues: noteTagLinks
                };

                sentinelResource.updateNote({noteId: visit.noteId}, noteToPatch).$promise.then(function () {
                    var commentText = "Check-in removed";
                    sentinelResource.addComment({note: visit.noteLink, comment: commentText}).$promise.then(function () {
                        performRefresh();
                    });
                });
            });
        }
    };

    this.undoCheckoutVisitor = function (visit) {
        var noteTagLinks = [];
        var doorTagLink = null;
        var promises = [];

        if (visit.doorIn !== visit.doorOut) {
            promises.push(sentinelResource.getTagByName({
                log: $rootScope.selectedLog.id,
                stringValue: visit.doorOut.replace(/\s/g, '')
            }).$promise);
        }

        $q.all(promises).then(checkTagIds);

        function checkTagIds(data) {
            if (data.length > 0) {
                doorTagLink = data[0]._embedded.tagValues[0]._links.self.href;
            }
            sentinelResource.getTagByNote({noteId: visit.noteId}).$promise.then(function (data) {
                noteTagLinks = data._embedded.tagValues.map(function (tagValue) {
                    return tagValue._links.self.href;
                });

                if (Array.prototype.includes) {
                    if (noteTagLinks.includes(doorTagLink)) {
                        noteTagLinks.splice(noteTagLinks.indexOf(doorTagLink), 1);
                    }
                } else {
                    for (var i = 0; i < noteTagLinks.length; i++) {
                        if (noteTagLinks[i] === doorTagLink) {
                            noteTagLinks.splice(noteTagLinks.indexOf(doorTagLink), 1);
                            break;
                        }
                    }
                }

                visit.doorOut = null;
                visit.escortOut = null;
                visit.checkOutTime = null;
                visit.lastEdit = new Date();
                patchNote();
            });
        }

        function patchNote() {
            transformVisitToTemplateData(sentinel.templateSegments, visit, true).then(function (noteTemplateValues) {
                var noteToPatch = {
                    noteTemplateValues: noteTemplateValues,
                    tagValues: noteTagLinks
                };

                sentinelResource.updateNote({noteId: visit.noteId}, noteToPatch).$promise.then(function () {
                    var commentText = "Check-out removed";
                    sentinelResource.addComment({note: visit.noteLink, comment: commentText}).$promise.then(function () {
                        performRefresh();
                    });
                });
            });
        }
    };

    this.editVisitor = function(visit) {
        var promises = [];

        if (visit.pictureBase64) {
            promises.push(uploadAttachment(visit.pictureBase64, visit));
        }

        $q.all(promises).then(function (data) {
            if (data[0]) {
                visit.profilePicture = data[0].data.id;
            }
            visit.lastEdit = new Date();

            transformVisitToTemplateData(sentinel.templateSegments, visit).then(function (noteTemplateValues) {
                var noteToPatch = {
                    noteTemplateValues: noteTemplateValues,
                    newAttachments: []
                };

                if (visit.profilePicture) {
                    noteToPatch.newAttachments = [visit.profilePicture];
                }

                sentinelResource.updateNote({noteId: visit.noteId}, noteToPatch).$promise.then(function() {
                    var commentText = "Visit edited on the web";
                    sentinelResource.addComment({note: visit.noteLink, comment: commentText}).$promise.then(function () {
                        performRefresh();
                    });
                });
            });
        });
    };

    this.removeVisitor = function (visit) {
        sentinelResource.removeNote({noteId: visit.noteId}).$promise.then(function() {
            performRefresh();
        });
    };

    this.addComment = function (visit, comment) {
        sentinelResource.addComment({note: visit.noteLink, comment: comment}).$promise.then(function () {
            performRefresh();
        });
    };

    this.setFacilityFilter = function (facility) {
        if (!facility) facility = "";
        var searchCriteria = sentinelSearchCriteriaFactory.get();
        searchCriteria.facilityFilter = facility.replace(/'/g, "\\\\'").replace(/\"/g, '\\\"');
        sentinelSearchCriteriaFactory.set(searchCriteria);
        performSearch();
    };

    function performSearch () {
        if (sentinel.initialized) {
            if (sentinel.activeTab === 'check-in') {
                if (sentinel.registeredPromise) {
                    sentinel.registeredPromise.cancelRequest().then(function () {
                        sentinel.registeredPromise = null;
                        getRegisteredGuests(true);
                    });
                } else {
                    getRegisteredGuests(true);
                }
            } else if (sentinel.activeTab === 'check-out') {
                if (sentinel.activePromise) {
                    sentinel.activePromise.cancelRequest().then(function () {
                        sentinel.activePromise = null;
                        getActiveVisitors(true);
                    });
                } else {
                    getActiveVisitors(true);
                }
            } else if (sentinel.activeTab === 'visits') {
                if (sentinel.searchPromise) {
                    sentinel.searchPromise.cancelRequest().then(function () {
                        sentinel.searchPromise = null;
                        getData();
                    });
                } else {
                    getData();
                }
            }
        }
    }

    function performRefresh() {
        if (sentinel.activeTab === 'check-in') {
            if (sentinel.registeredPromise) {
                sentinel.registeredPromise.cancelRequest().then(function () {
                    sentinel.registeredPromise = null;
                    getRegisteredGuests(true);
                });
            } else {
                getRegisteredGuests(true);
            }
        } else if (sentinel.activeTab === 'check-out') {
            if (sentinel.activePromise) {
                sentinel.activePromise.cancelRequest().then(function () {
                    sentinel.activePromise = null;
                    getActiveVisitors(true);
                });
            } else {
                getActiveVisitors(true);
            }
        } else if (sentinel.activeTab === 'visits') {
            if (sentinel.searchPromise) {
                sentinel.searchPromise.cancelRequest().then(function () {
                    sentinel.searchPromise = null;
                    updateData();
                });
            } else {
                updateData();
            }
        }
    }

    this.setActiveTab = function (tab) {
        sentinel.activeTab = tab;
        performSearch();

        localStorage.setItem('sentinelTab', tab);
    };

    this.getActiveTab = function () {
        return sentinel.activeTab;
    };

    this.updateSearchCriteria = function () {
        sentinel.searchCriteria = sentinelSearchCriteriaFactory.get();
        performSearch();
    };

    this.refresh = function () {
        performRefresh();
    };

    this.getSelectedFacility = function () {
      return sentinel.searchCriteria.facilityFilter;
    };

    this.finalize = function () {
        $interval.cancel(sentinel.updateInterval);

        var promises = [];

        if (sentinel.searchPromise) {
            promises.push(sentinel.searchPromise.cancelRequest());
        }
        if (sentinel.registeredPromise) {
            promises.push(sentinel.registeredPromise.cancelRequest());
        }
        if (sentinel.activePromise) {
            promises.push(sentinel.activePromise.cancelRequest());
        }

        sentinel.initialized = false;
        sentinel.logId = null;
        sentinel.callbacks = [];
        sentinel.visitData.registeredGuests.splice(0, sentinel.visitData.registeredGuests.length);
        sentinel.visitData.activeVisitors.splice(0, sentinel.visitData.activeVisitors.length);
        sentinel.visitData.visits.splice(0, sentinel.visitData.visits.length);
        sentinel.latestRegistered = moment("01-01-2017", "MM-DD-YYYY");
        sentinel.latestActive = moment("01-01-2017", "MM-DD-YYYY");
        sentinel.latest = moment().startOf('day');
        sentinel.facilities = {};
        sentinel.facilitiesLastUpdated = null;
        sentinel.facilityUpdatePromise = null;
        sentinelSearchCriteriaFactory.set({
            searchTerm: null,
            useDateRange: false,
            showComments: false,
            fromDate: moment().startOf('day'),
            thruDate: moment().endOf('day'),
            page: 0,
            size: 10000
        });

        return $q.all(promises);
    };

    this.init = function (logId, callback) {
        sentinel.logId = logId;
        sentinel.callbacks.push(callback);

        $rootScope.$watch(function () {
            return sentinel.visitData;
        }, function (newValue) {
            if (newValue) {
                sentinel.callbacks.forEach(function (callback) {
                    callback(newValue);
                });
            }
        });

        sentinelResource.getTemplateData().$promise.then(function(data) {
            sentinel.templateData = data._embedded.templates[0];
        });
        sentinelResource.getTemplateSegments().$promise.then(function(data) {
           sentinel.templateSegments = data._embedded.templateSegments;
        });

        var promises = [];

        $q.all(promises).then(function() {
            sentinel.updateInterval = $interval(function () {
                if (sentinel.activeTab === 'check-in' && !sentinel.registeredPromise) {
                    getRegisteredGuests(true);
                } else if (sentinel.activeTab === 'check-out' && !sentinel.activePromise) {
                    getActiveVisitors(true);
                } else if (sentinel.activeTab === 'visits' && ((sentinel.searchCriteria.useDateRange && moment().isSame(sentinel.searchCriteria.thruDate, 'day')) || (!sentinel.searchCriteria.useDateRange && moment().isSame(sentinel.searchCriteria.fromDate, 'day'))) && !sentinel.searchPromise) {
                    updateData();
                } else {
                    console.log('Update interval did not meet necessary criteria!');
                    console.log('sentinel.activeTab: ');
                    console.log(sentinel.activeTab);
                    console.log('sentinel.registeredPromise: ');
                    console.log(sentinel.registeredPromise);
                    console.log('sentinel.activePromise: ');
                    console.log(sentinel.activePromise);
                    console.log('sentinel.searchPromise: ');
                    console.log(sentinel.searchPromise);
                    console.log('sentinel.searchCriteria.useDateRange: ' + sentinel.searchCriteria.useDateRange);
                    console.log('sentinel.searchCriteria.fromDate: ');
                    console.log(sentinel.searchCriteria.fromDate);
                    console.log('sentinel.searchCriteria.thruDate: ');
                    console.log(sentinel.searchCriteria.thruDate);
                }
            }, refreshTimeout);

            sentinel.initialized = true;
        });
    };

    this.sentinel = sentinel;
}

angular.module("sentinel").service("sentinelService", ["$interval", "$q", "$resource", "$rootScope", "$location", "$http", "sentinelSearchCriteriaFactory", SentinelService]);
